export default __webpack_public_path__ + "static/media/cp_geo_nz.9aa89d3e.svg";